<template>
  <form class="card-sakali"
        @submit.prevent="submit">
    <div class="form-group">
      <label for="passwordInput">Neues Passwort</label>
      <input id="passwordInput"
             class="form-control"
             type="password"
             v-model="password"/>
    </div>
    <div class="form-group">
      <label for="passwordRepeatInput">Passwort wiederholen</label>
      <input id="passwordRepeatInput"
             class="form-control"
             type="passwordRepeat"
             v-model="passwordRepeat"/>
    </div>
    <div class="form-group">
      <button class="btn form-control btn-sakali mt-2"
              :disabled="!password || !passwordRepeat || password !== passwordRepeat || password.length === 0"
              @click.prevent="submit">
        Speichern
      </button>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    token: String
  },
  data() {
    return {
      password: '',
      passwordRepeat: ''
    }
  },
  methods: {
    submit() {
      this.$api.post('/passwords', {
        token: this.token,
        newPassword: this.password,
        newPasswordRepeat: this.passwordRepeat
      }).then(() => {
        this.showMessage('Dein Passwort wurde geändert. Bitte logge Dich mit dem neuen Passwort ein!')
        this.$router.push({name: 'login'})
      }).catch(error => this.handleError(error))
    }
  }
}
</script>